import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import { Box, Button, Card, Stack, Typography } from '@mui/material';
import Label from '@/components/label';
import { BUSINESS_REQUIREMENT_STEP_STATE } from '@/consts/businessRequirements';

// O tema capitaliza cada palavra do botao, o que vira "Fazer Pré-cadastro". O
// protótipo escreve em frase, entao estas telas desligam a regra.
const BOTAO_EM_FRASE = { textTransform: 'none' };

const MARKER_SIZE = 28;

const { DONE, PENDING } = BUSINESS_REQUIREMENT_STEP_STATE;

const StepMarker = ({ number, state }) => (
  <Box
    sx={{
      width: MARKER_SIZE,
      height: MARKER_SIZE,
      flexShrink: 0,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...(state === DONE && { color: 'common.white', bgcolor: 'success.main' }),
      ...(state === PENDING && {
        color: 'text.disabled',
        bgcolor: (theme) => alpha(theme.palette.grey[500], 0.16),
      }),
      // O estado atual mantem o verde, mas rebaixado, como no protótipo: o selo
      // e que muda de cor quando a etapa esta em analise ou reprovada.
      ...(state !== DONE &&
        state !== PENDING && {
          color: 'success.main',
          bgcolor: (theme) => alpha(theme.palette.success.main, 0.16),
        }),
    }}
  >
    <Typography variant="caption" sx={{ fontWeight: 'fontWeightBold' }}>
      {number}
    </Typography>
  </Box>
);

StepMarker.propTypes = {
  number: PropTypes.number,
  state: PropTypes.string,
};

export default function BusinessRequirementStep({ step, onAction }) {
  const isPending = step.state === PENDING;

  return (
    <Card sx={{ p: 2.5, ...(isPending && { boxShadow: 'none' }) }}>
      <Stack
        spacing={2}
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ sm: 'center' }}
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ minWidth: 0 }}>
          <StepMarker number={step.number} state={step.state} />

          <Stack spacing={0.25} sx={{ minWidth: 0 }}>
            <Stack direction="row" alignItems="center" spacing={0.75}>
              <Typography
                variant="subtitle2"
                sx={{ color: isPending ? 'text.disabled' : 'text.primary' }}
              >
                {step.title}
              </Typography>

              {step.badge && (
                <Label
                  variant="soft"
                  color={step.badge.color}
                  sx={{ flexShrink: 0, height: 20, px: 0.75, fontSize: 11, textTransform: 'none' }}
                >
                  {step.badge.label}
                </Label>
              )}
            </Stack>

            <Typography
              variant="body2"
              sx={{ color: isPending ? 'text.disabled' : 'text.secondary' }}
            >
              {step.description}
            </Typography>
          </Stack>
        </Stack>

        {step.action && (
          <Button
            sx={{ ...BOTAO_EM_FRASE, flexShrink: 0 }}
            variant={step.action.secondary ? 'outlined' : 'contained'}
            color={step.action.secondary ? 'inherit' : 'primary'}
            onClick={() => onAction(step.action.id)}
          >
            {step.action.label}
          </Button>
        )}
      </Stack>
    </Card>
  );
}

BusinessRequirementStep.propTypes = {
  step: PropTypes.object.isRequired,
  onAction: PropTypes.func.isRequired,
};
